const BOOLEAN_STRING_OR_NUMBER = new Set(['boolean', 'string', 'number']);
export var FieldType;
(function (FieldType) {
    FieldType["String"] = "string";
    FieldType["Number"] = "number";
    FieldType["Enum"] = "enum";
    FieldType["Boolean"] = "boolean";
    FieldType["ArrayOfEnum"] = "array_of_enum";
    FieldType["EncryptedString"] = "encrypted_string";
    FieldType["Date"] = "Date";
    FieldType["DocumentUpload"] = "document_upload";
})(FieldType || (FieldType = {}));
export function isMfValidationOptionValue(o) {
    return typeof (o) === 'object'
        && BOOLEAN_STRING_OR_NUMBER.has(typeof (o.value));
}
export function isMfValidationOptionPathToValue(o) {
    return typeof (o) === 'object'
        && typeof (o.pathToValue) === 'string';
}
